/**
 * Pre-Seed Page - October 2026
 * Password-gated fullscreen slide deck viewer
 */

import React from 'react';
import { PitchDeck, PRESEED_OCT_2026 } from '@components/press/pitch-deck';

export const PreseedOct2026Page: React.FC = () => <PitchDeck edition={PRESEED_OCT_2026} />;
